import React from 'react'
import { func, number, arrayOf, bool } from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { click } from 'utils/tracker'
import { sceneType } from 'models/propTypes'

import Icon from 'components/uiElements/Icon'

require('./SceneSelection.scss')

const SceneSelection = ({
    userSceneItems,
    stockSceneItems,
    onSelectScene,
    selectedSceneId,
    close,
    viewUserScenes,
    viewStockScenes,
    showStockTab,
}) => {
    const { t } = useTranslation()
    return (
        <div className={classNames('SceneSelection')}>
            <div className="sceneSelectionContent">
                <Icon code="cross" className="selectionClose" onClick={close} />
                <div className="selectionHeader">
                    <h1>{t('design.select a room')}</h1>
                    <h2>{t('design.pick model room')}</h2>
                </div>
                {userSceneItems.length ? (
                    <div className="selectionTabBar">
                        <button onClick={viewUserScenes} className={classNames({ selected: !showStockTab })}>
                            {t('design.my rooms')}
                        </button>
                        <button onClick={viewStockScenes} className={classNames({ selected: showStockTab })}>
                            {t('design.showrooms')}
                        </button>
                    </div>
                ) : null}
                <div className="sceneItemsContainer">
                    <div className="sceneItems">
                        {showStockTab && !userSceneItems.length ? (
                            <div className="sceneThumbContainer">
                                <div className="sceneThumb cta">
                                    <div className="thumb" />
                                    <p>{t('design.download app')}</p>
                                    <img
                                        src={`${ASSET_BUCKET}/graphics/iosBadge.svg`}
                                        alt={t('design.alt.no user uploaded rooms')}
                                    />
                                    <span>{t('design.coming soon')}</span>
                                </div>
                            </div>
                        ) : null}
                        {(showStockTab ? stockSceneItems : userSceneItems).map((item) => {
                            const selected = item.sceneId === selectedSceneId

                            return (
                                <div
                                    className="sceneThumbContainer"
                                    key={item.sceneId}
                                    onClick={() => {
                                        click('DecorateRoom.ChangeRoom', {
                                            RoomTitle: item.name,
                                            RoomId: item.sceneId,
                                            RoomSource: item.isStock ? 'Stock' : 'UserCaptured',
                                        })
                                        onSelectScene(item.sceneId)
                                        close()
                                    }}
                                >
                                    <div className={classNames('sceneThumb', { selected })}>
                                        <div
                                            className="thumb"
                                            style={{ backgroundImage: `url('${item.thumbUrl || item.panoUrl}')` }}
                                        />
                                        <div className="text">{item.name}</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

SceneSelection.defaultProps = {
    selectedSceneId: null,
}

SceneSelection.propTypes = {
    userSceneItems: arrayOf(sceneType).isRequired,
    stockSceneItems: arrayOf(sceneType).isRequired,
    onSelectScene: func.isRequired,
    selectedSceneId: number,
    close: func.isRequired,
    viewUserScenes: func.isRequired,
    viewStockScenes: func.isRequired,
    showStockTab: bool.isRequired,
}

export default SceneSelection
